module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"YashBrahmkshatriya","short_name":"YashBrahmkshatriya","description":"Full stack developer, competitive coder, and VSCode lover 😜","start_url":"/","icon":"src/images/logo.png","theme_color":"#04C3C9","background_color":"#1B212C","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"114894bb38dffc6876939a4168c1cada"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
